<script setup lang="ts">
import { Check, Moon } from 'lucide-vue-next'

// Principles of Islamic financing instead of specific providers
const { t } = useI18n()

const points = ['no_interest', 'known_markup', 'real_goods'] as const
</script>

<template>
  <div class="relative w-[21rem] select-none" aria-hidden="true">
    <div class="absolute inset-x-6 -top-2 h-full rotate-3 rounded-2xl bg-emerald-100" />

    <div class="HeroIllustrationCard">
      <div class="flex items-center gap-3">
        <span class="grid size-11 place-items-center rounded-xl bg-emerald-600 text-white">
          <Moon class="size-5" />
        </span>
        <div>
          <div class="font-serif text-xl font-bold">{{ t('widget.hero_banner.illustration.islamic.title') }}</div>
          <div class="text-sm text-gray-500">{{ t('widget.hero_banner.illustration.islamic.subtitle') }}</div>
        </div>
      </div>

      <ul class="mt-4 space-y-1.5">
        <li v-for="point in points" :key="point" class="flex items-center gap-3 rounded-xl bg-emerald-50 px-3 py-2">
          <Check class="size-4 shrink-0 text-emerald-600" />
          <span class="text-sm font-semibold">{{ t(`widget.hero_banner.illustration.islamic.${point}`) }}</span>
        </li>
      </ul>
    </div>

    <div class="HeroIllustrationSticker -bottom-4 -left-8 text-sm font-semibold">
      {{ t('widget.hero_banner.illustration.islamic.sharia') }}
    </div>
  </div>
</template>
